<h2 mat-dialog-title>{{ 'orders.addOrderToBundle' | transloco }}</h2>
<mat-dialog-content>
  <div class="flex-container">
    <mat-form-field class="flex-item form-field" appearance="outline">
      <mat-label>{{ 'orders.bundle' | transloco }}</mat-label>
      <mat-select name="bundle" [(ngModel)]="selectedBundleIDs" multiple="true">
        @for (bundle of bundles; track bundle) {
          <mat-option [value]="bundle.value">
            {{bundle.label}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.cancel' | transloco }}</button>
  <button mat-raised-button [disabled]="!selectedBundleIDs" color="primary" (click)="addToBundle()" [mat-dialog-close]="true">{{ 'common.buttons.add' | transloco }}</button>
</mat-dialog-actions>